import fetchData from '../fetch/index.tsx';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => fetchData('issue-create');
